import React from "react";
import OperationalResource from "../components/OperationalResource";
export default function Reserves() {
  return <OperationalResource title="Reserves" resource="reserves" />;
}
